import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import {
  CreateUpdateStateComplaintDocumentDto,
  CreateUpdateStateComplaintDto,
  StateComplaintDisputeDocumentDto,
  StateComplaintDto,
} from "../../models/dispute-resolution/state-complaint-models";

@Injectable({
  providedIn: "root",
})
export class StateComplaintService {
  private readonly baseUrl = "/api/dispute-resolution/state-complaint";
  private readonly partyBaseUrl = `${this.baseUrl}/parties`;
  private readonly documentBaseUrl = `${this.baseUrl}/documents`;

  constructor(private http: HttpClient) { }

  create(
    request: CreateUpdateStateComplaintDto
  ): Observable<StateComplaintDto> {
    return this.http.post<StateComplaintDto>(`${this.baseUrl}`, request);
  }

  getById(id: string): Observable<StateComplaintDto> {
    return this.http.get<StateComplaintDto>(`${this.baseUrl}/${id}`);
  }

  update(id: string, request: CreateUpdateStateComplaintDto): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/${id}`, request);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }

  getAll(): Observable<StateComplaintDto[]> {
    return this.http.get<StateComplaintDto[]>(`${this.baseUrl}`);
  }

  generateCaseNumber(isIdea: boolean): Observable<string> {
    return this.http.get(`${this.baseUrl}/generate-case-number/${isIdea}`, {
      responseType: "text",
    });
  }

  updateCaseStatus(
    disputeCaseId: string,
    workflowStatusChangesId: string
  ): Observable<void> {
    return this.http.put<void>(
      `${this.baseUrl}/update-case-status/${disputeCaseId}/${workflowStatusChangesId}`,
      null
    );
  }

  createDocument(
    request: CreateUpdateStateComplaintDocumentDto
  ): Observable<StateComplaintDisputeDocumentDto> {
    return this.http.post<StateComplaintDisputeDocumentDto>(
      `${this.documentBaseUrl}`,
      request
    );
  }

  getDocumentsByDisputeCase(
    disputeCaseId: string
  ): Observable<StateComplaintDisputeDocumentDto[]> {
    return this.http.get<StateComplaintDisputeDocumentDto[]>(
      `${this.documentBaseUrl}/case/${disputeCaseId}`
    );
  }

  deleteDocument(id: string): Observable<void> {
    return this.http.delete<void>(`${this.documentBaseUrl}/${id}`);
  }
}
